// @core/api/endpoints/apikey/get_api_key_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyPolicyResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get entity API key policy
 * Returns the API key policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveAPIKeyContext for that.
 */
export async function GetAPIKeyPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<APIKeyPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<APIKeyPolicyResponse>(requestPath, { ...requestOptions });
}
